import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DynamicReport from "../../Components/DynamicReport/DynamicReport";
import {
  EditOutlined,
  DeleteOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { Collapse, Divider, Form, message, Row, Tabs, Modal } from "antd";
import { Col } from "antd";
import { FormSelect } from "../../Components/FormSelect";
import { FormInput } from "../../Components/FormInputs";
import { FormCheckbox } from "../../Components/FormCheckbox";
import { API } from "../../Axios/Axios";
import {
  deletePOIConfiguration,
  getDropdowns,
  getPOIConfigurationById,
  insertUpdatePOIConfiguration,
  deletePOIAdditionalField,
} from "../../Helpers/APIEndpoints/Endpoints";
import { LoaderContext } from "../../Helpers/Context/Context";
import { useAuthStore } from "../../AuthStore/AuthStore";
import FinancialYearMaster from "../FinancialYearMaster/FinancialYearMaster";
import {
  ActionHandlerProvider,
  useActionHandler,
} from "../../Components/ActionHandlerContext";
import { resolve } from "path";
import { rejects } from "assert";
import TextArea from "antd/es/input/TextArea";

const { Panel } = Collapse;

interface IOptions {
  label?: string;
  value?: number | string;
  code?: string;
}

interface IFormData {
  financialYear?: IOptions | any;
  type?: IOptions | any;
  section?: IOptions | any;
  component?: IOptions | any;
  regime?: IOptions | any;
  criteria?: IOptions | any;
  category?: IOptions | any;
  maxLimit?: string | any;
  description?: string | any;
  documents?: IOptions | any;
  fieldName?: string | any;
  responseType?: IOptions | any;
  choices?: string | any;
  isMandatory?: string | any;
  isReplicable?: boolean | any;
  regex?: IOptions | any;
  // dependentFieldDropdown?: IOptions | any;
  // dependentFieldResponseDropdown?: IOptions | any;
}

interface IAdditionalField {
  id?: number | any;
  fieldName?: string | any;
  responseType?: string | any;
  choices?: string | any;
  minValue?: string | any;
  maxValue?: string | any;
  charLimit?: string | any;
  isMandatory?: string | any;
  regex?: string | any;
  // isDependent?: string | any;
  // dependentFieldDropdown?: string | any;
  // dependentFieldResponseDropdown?: string | any;
  // isHidden?: string | any;
}

export default function ConfigurationMaster() {
  const [form] = Form.useForm();
  const [RequestId, setRequestId] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [showAdditionalField, setShowAdditionalField] = useState(false);
  const [formData, setFormData] = useState<IFormData>({});
  const [formErrors, setFormErrors] = useState<IFormData>({});
  const [formOptions, setFormOptions] = useState<IFormData>({});
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [additionalFields, setAdditionalFields] = useState<IAdditionalField[]>(
    []
  );
  const { userId, currentRoleId, currentFinancialYearId } = useAuthStore();
  const [sectionMaxLimit, setSectionMaxLimit] = useState("");
  const [componentMaxLimit, setComponentMaxLimit] = useState("");
  const { rowActionHandler, reportActionHandler } = useActionHandler();
  const [additionalFormErrors, setAdditionalFormErrors] = useState<
    IAdditionalField[]
  >([]);
  const [refreshTable, setRefreshTable] = useState(true);

  const { confirm } = Modal;

  const regexOprions = [
    { value: 1, label: "PAN" },
    { value: 2, label: "Aadhar" },
    { value: 3, label: "Number" },
  ];

  const childRowHandlers = {
    ...rowActionHandler, // Merge Parent's rowActionHandler
    DynamicMasterRowEdit:
      //((record:any) => {
      (actionType: any, record: any) => {
        handleEditConfiguration(actionType, record);
        // setRequestId(record.Id);
        // getDropdownValues();
        // setShowForm(true);
      },
    DynamicMasterRowDelete: (actionType: any, record: any) => {
      return handleDeleteConfiguration(actionType, record);
    },
  };

  const childReportHandlers = {
    ...reportActionHandler,
    DynamicReportActionCreate:
      //(() => {
      (actionType: any, record: any) => {
        handleCreateConfiguration(actionType, record);
        // setRequestId(0);
        // getDropdownValues();
        // setShowForm(!showForm);
        // return true;
      },
  };

  const getDropdownValues = async () => {
    try {
      showLoader();

      let response = await API.post(getDropdowns, {
        //RegimeId : formData?.regime?.length  ? comma(formData?.regime) : null,
        RegimeId: null,
        SectionId: 0,
      });

      if (response.data && response.data.data) {
        setFormOptions((prev) => {
          return {
            ...prev,
            financialYear: response.data.data.financialYearList || [],
            type: response.data.data.typeList || [],
            section: response.data.data.sectionList || [],
            component: response.data.data.componentList || [],
            category: response.data.data.categoryList || [],
            criteria: response.data.data.criteriaList || [],
            documents: response.data.data.documentList || [],
            regime: response.data.data.regimeList || [],
            responseType: response.data.data.responseTypeList || [],
            regex: regexOprions || [],
          };
        });
      }
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      message.error(`Failed to perform getDropdowns`);
    } finally {
      hideLoader();
    }
  };

  const getSection = async () => {
    try {
      showLoader();

      let response = await API.post(getDropdowns, {
        RegimeId: comma(formData?.regime),
        SectionId: 0,
        Mode: "Section",
      });

      if (response.data && response.data.data) {
        setFormOptions((prev) => {
          return {
            ...prev,
            section: [],
          };
        });
        setFormOptions((prev) => {
          return {
            ...prev,
            section: response.data.data.sectionList || [],
          };
        });
      }
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      message.error(`Failed to perform getDropdowns`);
    } finally {
      hideLoader();
    }
  };

  const getComponent = async () => {
    try {
      showLoader();

      let response = await API.post(getDropdowns, {
        //RegimeId : formData?.regime?.length  ? comma(formData?.regime) : null,
        RegimeId: comma(formData?.regime),
        SectionId: formData?.section,
        Mode: "Component",
      });

      if (response.data && response.data.data) {
        setFormOptions((prev) => {
          return {
            ...prev,
            component: [],
          };
        });
        setFormOptions((prev) => {
          return {
            ...prev,
            component: response.data.data.componentList || [],
          };
        });
      }
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      message.error(`Failed to perform getDropdowns`);
    } finally {
      hideLoader();
    }
  };

  const getDocument = async () => {
    try {
      showLoader();

      let response = await API.post(getDropdowns, {
        TypeId: formData?.type,
        Mode: "Document",
      });

      if (response.data && response.data.data) {
        setFormOptions((prev) => {
          return {
            ...prev,
            documents: [],
          };
        });
        setFormOptions((prev) => {
          return {
            ...prev,
            documents: response.data.data.documentList || [],
          };
        });
      }
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      message.error(`Failed to perform getDropdowns`);
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    if (formData?.regime?.length > 0) {
      getSection();

      if (
        RequestId > 0 &&
        formData?.section > 0 &&
        formOptions?.section?.length > 0
      ) {
        form.setFieldsValue({
          section: formData?.section,
        });
      }
    }
  }, [formData?.regime]);

  useEffect(() => {
    if (formData?.type > 0) {
      getDocument();

      if (
        RequestId > 0 &&
        formData?.documents > 0 &&
        formOptions?.documents?.length > 0
      ) {
        form.setFieldsValue({
          document: formData?.documents,
        });
      }
    }
  }, [formData?.type]);

  useEffect(() => {
    if (formData?.section > 0) {
      getComponent();

      if (
        RequestId > 0 &&
        formData?.component > 0 &&
        formOptions?.component?.length > 0
      ) {
        form.setFieldsValue({
          component: formData?.component,
        });
      }
    }
  }, [formData?.section]);

  const resetFunction = () => {
    setAdditionalFields([]);
    setFormErrors({});
    setAdditionalFormErrors([]);

    //form.resetFields();

    form.setFieldsValue({
      //financialYear: [],
      type: [],
      regime: [],
      section: [],
      component: [],
      criteria: [],
      category: [],
      documents: [],
      maxLimit: "",
      description: "",
    });

    setFormData({
      //financialYear: [],
      type: null,
      regime: [],
      section: null,
      component: null,
      criteria: null,
      category: null,
      documents: [],
      maxLimit: "",
      description: "",
    });

    form.resetFields();
    // setAdditionalFields(prevFields =>
    //   prevFields.map(field => ({
    //     ...field,
    //     fieldName: "", responseType: "", choices: "",
    //     minValue: "", maxValue: "", charLimit: "", isMandatory: false
    //   }))
    // );
  };

  const addAdditionalField = () => {
    setAdditionalFields([
      ...additionalFields,
      {
        id: 0,
        fieldName: "",
        responseType: "",
        choices: "",
        minValue: "",
        maxValue: "",
        charLimit: "",
        regex: "",
        isMandatory: false,

        // isDependent: false,
        // dependentFieldDropdown: "",
        // dependentFieldResponseDropdown: "",
        // isHidden: false,
      },
    ]);

    // const dependentField = additionalFields?.filter(
    //   (env) =>
    //     env?.responseType.toLocaleLowerCase().trim() === "choices" ||
    //     env?.responseType.toLocaleLowerCase().trim() === "dropdown"
    // );

    // const result = dependentField?.map((val, index) => ({
    //   label: val?.fieldName,
    //   value: val?.fieldName,
    // }));

    // setFormOptions((prev) => {
    //   return {
    //     ...prev,
    //     dependentFieldDropdown: result,
    //   };
    // });
  };

  const toggleAdditionalField = () => {
    setShowAdditionalField(!showAdditionalField);
  };

  const comma = (data: any) => {
    return data?.length > 0 ? data.map((s: any) => s).join(",") : null;
  };

  const handleCreateConfiguration = (Type: string, RId: number) => {
    setRequestId(0);
    getDropdownValues();
    setShowForm(!showForm);
    setShowAdditionalField(!showAdditionalField);
    setAdditionalFields([]);
    resetFunction();
    setFormErrors({});
  };

  const handleEditConfiguration = (actionType: string, record: any) => {
    //getDropdownValues();
    setRequestId(record.Id);
    getDropdownValues();
    setShowForm(true);
    setShowAdditionalField(true);
    resetFunction();
    //getConfigurationById(record.Id);
  };

  useEffect(() => {
    if (
      formOptions?.financialYear?.length > 0 &&
      formOptions?.type?.length > 0 &&
      formOptions?.regime?.length > 0 &&
      formOptions?.category?.length > 0 &&
      RequestId > 0
    ) {
      getConfigurationById(RequestId);
    } else {
      const financialYearObj = formOptions?.financialYear?.find(
        (prev: any) => prev?.value === currentFinancialYearId
      );
      form.setFieldsValue({
        financialYear: financialYearObj,
      });

      setFormData({
        financialYear: currentFinancialYearId,
      });
    }
  }, [
    formOptions?.financialYear,
    formOptions?.type,
    formOptions?.regime,
    formOptions?.category,
    RequestId,
  ]);

  const handleDeleteConfiguration = async (
    actionType: string,
    record: any
  ): Promise<boolean> => {
    //var result = false;
    //result = window.confirm("Are you sure you want to delete ?");

    return new Promise((resolve) => {
      confirm({
        content: "Are you sure you want to delete ?",
        okText: "Ok",
        cancelText: "Cancel",
        async onOk() {
          try {
            showLoader();

            let response = await API.post(deletePOIConfiguration, {
              Id: record.Id,
            });

            if (response.data) {
              message.success("Deleted successfully.");
              resolve(true);
            } else {
              message.success("Failed to delete");
              resolve(false);
            }
          } catch (error) {
            hideLoader();
            //console.error("Error:", error);
            //console.error("Error:", error.response.data);

            message.error(`Failed to perform`);
            resolve(false);
          } finally {
            hideLoader();
          }
        },
        onCancel() {
          resolve(false);
        },
      });
    });
  };

  const formOnChange = (e: any, mode: any) => {
    console.log('form is changing ')
    switch (mode) {
      case "financialYear":
        setFormData({
          ...formData,
          financialYear: e,
        });
        setFormErrors((pre)=>({
            ...pre,
            financialYear: "",
        }))

        break;
      case "type":
        setFormData({
          ...formData,
          type: e,
        });

        setFormErrors((pre)=>({
            ...pre,
            type: "",
        }))

        break;
      case "section":
        setFormData({
          ...formData,
          section: e,
        });

        setFormErrors((pre)=>({
            ...pre,
            section: "",
        }))

        break;
      case "component":
        setFormData({
          ...formData,
          component: e,
        });

        setFormErrors((pre)=>({
            ...pre,
            component: "",
        }))
        break;
      case "regime":
        setFormData({
          ...formData,
          regime: e,
        });

         setFormErrors((pre)=>({
            ...pre,
            regime: "",
        }))
        break;

      case "criteria":
        setFormData({
          ...formData,
          criteria: e,
        });

         setFormErrors((pre)=>({
            ...pre,
            criteria: "",
        }))
        break;
      case "category":
        setFormData({
          ...formData,
          category: e,
        });

        setFormErrors((pre)=>({
            ...pre,
            category: "",
        }))
        break;

      case "maxLimit":
        setFormData({
          ...formData,
          maxLimit: e.target.value,
        });

        setFormErrors((pre)=>({
            ...pre,
            maxLimit: "",
        }))
        break;
      case "description":
        setFormData({
          ...formData,
          description: e.target.value,
        });
        setFormErrors((pre)=>({
            ...pre,
            description: "",
        }))
        break;
      case "documents":
        setFormData({
          ...formData,
          documents: e,
        });

        setFormErrors((pre)=>({
            ...pre,
            documents: "",
        }))
        break;

      case "isReplicable":
        setFormData({
          ...formData,
          isReplicable: e,
        });

        setFormErrors((pre)=>({
            ...pre,
            isReplicable: "",
        }))
        break;

      default:
        break;
    }
  };

  const additionalFormOnChange = (e: any, type: any, index: any) => {
    const updatedFields = [...additionalFields];
    console.log('type ',type ,index)
    console.log('list',additionalFormErrors)
    const match = type.match(/^(.+?)(\d+)$/);
    const fieldName = match[1]; // "fieldName"
    setAdditionalFormErrors((pre)=>({
              ...pre,
              [index]:{
                ...pre[index],
                [fieldName]:""
              },
          }))
    switch (type) {
      case "fieldName" + index:
        updatedFields[index] = {
          ...updatedFields[index],
          fieldName: e.target.value,
        };
        setAdditionalFields(updatedFields);
        break;
      case "responseType" + index:
        updatedFields[index] = {
          ...updatedFields[index],
          responseType: e,
        };
        setAdditionalFields(updatedFields);
        break;
      case "regex" + index:
        updatedFields[index] = {
          ...updatedFields[index],
          regex: e,
        };
        setAdditionalFields(updatedFields);
        break;
      case "choices" + index:
        updatedFields[index] = {
          ...updatedFields[index],
          choices: e.target.value,
        };
        setAdditionalFields(updatedFields);
        break;
      case "minValue" + index:
        updatedFields[index] = {
          ...updatedFields[index],
          minValue: e.target.value,
        };
        setAdditionalFields(updatedFields);
        break;
      case "maxValue" + index:
        updatedFields[index] = {
          ...updatedFields[index],
          maxValue: e.target.value,
        };
        setAdditionalFields(updatedFields);
        break;
      case "charLimit" + index:
        updatedFields[index] = {
          ...updatedFields[index],
          charLimit: e.target.value,
        };
        setAdditionalFields(updatedFields);
        break;
      // case "isDependent" + index:
      //   updatedFields[index] = {
      //     ...updatedFields[index],
      //     isDependent: e.target.checked,
      //     dependentFieldDropdown: null,
      //     dependentFieldResponseDropdown: null,
      //     isHidden: false,
      //   };
      //   setAdditionalFields(updatedFields);
      //   break;

      // case "dependentFieldDropdown" + index:
      //   updatedFields[index] = {
      //     ...updatedFields[index],
      //     dependentFieldDropdown: e,
      //   };
      //   setAdditionalFields(updatedFields);
      //   break;

      // case "dependentFieldResponseDropdown" + index:
      //   updatedFields[index] = {
      //     ...updatedFields[index],
      //     dependentFieldResponseDropdown: e,
      //   };
      //   setAdditionalFields(updatedFields);
      //   break;

      // case "isHidden" + index:
      //   updatedFields[index] = {
      //     ...updatedFields[index],
      //     isHidden: e.target.checked,
      //   };
      //   setAdditionalFields(updatedFields);
      //   break;

      case "isMandatory" + index:
        updatedFields[index] = {
          ...updatedFields[index],
          isMandatory: e.target.checked,
        };
        setAdditionalFields(updatedFields);
        break;
      default:
        break;
    }
  };

  const clearAllErrors = () => {
  const allErrors = form.getFieldsError();

  const clearedErrors = allErrors.map((field) => ({
    name: field.name,
    errors: [], // ✅ clear all errors
  }));

  form.setFields(clearedErrors);
};

  const validateForm = () => {
    let errorObj = {};
    let adderrorObj: IAdditionalField[] = [];
    let isError = false;
    let isAddError = false;
    
    console.log('form regime is while validation message',formData?.regime)
    setFormErrors({});
    setAdditionalFormErrors([]);
    clearAllErrors();
    if (
      formData?.financialYear === "" ||
      formData?.financialYear === null ||
      formData?.financialYear === undefined ||
      formData?.financialYear?.length <= 0
    ) {
      errorObj = {
        ...errorObj,
        ["financialYear"]: "Financial Year is required",
      };
    } else {
      errorObj = {
        ...errorObj,
        ["financialYear"]: "",
      };
    }
    if (
      formData?.type === "" ||
      formData?.type === null ||
      formData?.type === undefined ||
      formData?.type?.length <= 0
    ) {
      errorObj = {
        ...errorObj,
        ["type"]: "Type is required",
      };
    } else {
      errorObj = {
        ...errorObj,
        ["type"]: "",
      };
    }
    if (
      formData?.regime === "" ||
      formData?.regime === null ||
      formData?.regime === undefined ||
      formData?.regime?.length <= 0
    ) {
      errorObj = {
        ...errorObj,
        ["regime"]: "Regime is required",
      };
    } else {
      errorObj = {
        ...errorObj,
        ["regime"]: "",
      };
    }
    if (
      formData?.section === "" ||
      formData?.section === null ||
      formData?.section === undefined ||
      formData?.section?.length <= 0
    ) {
      errorObj = {
        ...errorObj,
        ["section"]: "Section is required",
      };
    } else {
      errorObj = {
        ...errorObj,
        ["section"]: "",
      };
    }
    if (
      formData?.category === "" ||
      formData?.category === null ||
      formData?.category === undefined||
      formData?.category?.length <= 0
    ) {
      errorObj = {
        ...errorObj,
        ["category"]: "Category is required",
      };
    } else {
      errorObj = {
        ...errorObj,
        ["category"]: "",
      };
    }
    if (
      formData?.documents === "" ||
      formData?.documents === null ||
      formData?.documents === undefined||
      formData?.documents?.length <= 0
    ) {
      errorObj = {
        ...errorObj,
        ["documents"]: "Documents is required",
      };
    } else {
      errorObj = {
        ...errorObj,
        ["documents"]: "",
      };
    }

    additionalFields.forEach((item, index) => {
      const error: IAdditionalField = {};
      if (
        item?.fieldName === "" ||
        item?.fieldName === null ||
        item?.fieldName === undefined ||
        item.fieldName.trim() === ""
      ) {
        error.fieldName = "Field name is required";
      } else {
        error.fieldName = "";
      }

      if (
        item?.responseType === "" ||
        item?.responseType === null ||
        item?.responseType === undefined ||
        item?.responseType?.length <= 0
      ) {
        error.responseType = "Response type is required";
      } else {
        error.responseType = "";
      }

      if (item?.responseType?.toLocaleLowerCase() == "numeric") {
        if (
          item?.minValue === "" ||
          item?.minValue === null ||
          item?.minValue === undefined ||
          item.fieldName.trim() === ""
        ) {
          error.minValue = "Min value is required";
        } else {
          error.minValue = "";
        }
        if (
          item?.maxValue === "" ||
          item?.maxValue === null ||
          item?.maxValue === undefined||
          item.fieldName.trim() === ""
        ) {
          error.maxValue = "Max value is required";
        } else {
          error.maxValue = "";
        }
      } else if (item?.responseType?.toLocaleLowerCase() == "text input") {
        if (
          item?.charLimit === "" ||
          item?.charLimit === null ||
          item?.charLimit === undefined||
          item.fieldName.trim() === ""
        ) {
          error.charLimit = "Char limit is required";
        } else {
          error.charLimit = "";
        }
      } else if (
        item?.responseType?.toLocaleLowerCase() == "choices" ||
        item?.responseType?.toLocaleLowerCase() == "radio button" || 
        item?.responseType?.toLocaleLowerCase() == "dropdown"
      ) {
        if (
          item?.choices === "" ||
          item?.choices === null ||
          item?.choices === undefined
        ) {
          error.choices = "Choices is required";
        } else {
          error.choices = "";
        }
      }
      adderrorObj[index] = error;
    });

    const isEmptyData = Object.values(errorObj).every((s) => s === "");

    if (Object.keys(errorObj).length > 0 && !isEmptyData) {
      isError = true;
      setFormErrors((err) => ({
        ...err,
        ...errorObj,
      }));
    }

    //const isEmptyAddData = Object.values(adderrorObj).every((s) => s === "");
    const isEmptyAddData = adderrorObj.every((obj) =>
      Object.values(obj).every((value) => value === "")
    );

    if (Object.keys(adderrorObj).length > 0 && !isEmptyAddData) {
      isAddError = true;
      setAdditionalFormErrors((adderr) => ({
        ...adderr,
        ...adderrorObj,
      }));
    }

    if (isError == true || isAddError == true) {
      return true;
    } else {
      return false;
    }

    //return isError;
  };

  const handleSaveFunction = async () => {
    if (validateForm()) {
      hideLoader();
      return;
    }
    try {
      debugger;
      showLoader();
      const validate = await form.validateFields();

      await insertUpdateConfigurationData();
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      //message.error(`Failed to perform data save`);
    } finally {
      hideLoader();
    }
  };

  const bindMaxLimit = async (value: any, type: any) => {
    form.setFieldsValue({
      maxLimit: value,
    });
    setFormData({
      ...formData,
      maxLimit: value,
    });
    // setFormData(prev => {
    //   const updated = {
    //     ...prev,
    //     maxLimit: value,
    //   };
    //   console.log('Updated formData:', updated);
    //   return updated;
    // });
    // setFormData({
    //   ...formData,
    //   maxLimit: value,
    // });
  };

  useEffect(() => {
    if(refreshTable == false)
    {
      setRefreshTable(true);
    }
  }, [refreshTable]);

  // useEffect(() => {
  //   console.log('additionalFields changed:', additionalFields);
  // }, [additionalFields]);

  const requestParamsFun = () => {
    const requestParams = {
      Id: RequestId,
      FinancialYearId: formData.financialYear || null,
      TypeId: formData.type || null,
      RegimeId: comma(formData.regime) || null,
      SectionId: formData.section || null,
      ComponentId: formData.component || null,
      CriteriaId: formData.criteria || null,
      CategoryId: formData.category || null,
      MaxLimit: formData.maxLimit || null,
      Description: formData.description || null,
      DocumentId: comma(formData.documents) || null,
      strAdditionalFieldList: JSON.stringify(additionalFields),
      IsReplicable: formData?.isReplicable,
      CreatedBy: userId,
      roleId: currentRoleId,
    };

    return requestParams;
  };

  const insertUpdateConfigurationData = async () => {
    showLoader();

    const requestParams = requestParamsFun();

    const response = await API.post(
      insertUpdatePOIConfiguration,
      requestParams
    );

    if (response?.data.status === 0) {
      const id = response?.data?.id;
      setShowForm(false);
      setShowAdditionalField(false);
      resetFunction();
      setAdditionalFields([]);

      setRefreshTable(false);
      
      message.success(RequestId == 0 ? "Data Created Successfully." : "Updated successfully.");
    } else if (response?.data.status === 1) {
      message.error("Failed to create data.");
    }

    hideLoader();
  };

  const getConfigurationById = async (Id: any) => {
    showLoader();
    try {
      const requestparam = {
        Id: Id,
      };
      const response = await API.post(getPOIConfigurationById, requestparam);

      if (response.data.status == 0) {
        const responseData = response.data.data;

        const financialYearObj = formOptions?.financialYear?.find(
          (prev: any) => prev?.value === responseData?.financialYearId
        );

        const typeObj = formOptions?.type?.find(
          (prev: any) => prev?.value === responseData?.typeId
        );

        // const regimeObj = formOptions?.regime?.find(
        //   (prev: any) => prev?.value === responseData?.regimeId
        // );
        const regimeObj = responseData?.regimeId
          ?.split(",")
          .map((val: any) => val.trim())
          .map((val: any) => Number(val));

        const sectionObj = formOptions?.section?.find(
          (prev: any) => prev?.value === responseData?.sectionId
        );

        const componentObj = formOptions?.component?.find(
          (prev: any) => prev?.value === responseData?.componentId
        );

        const criteriaObj = formOptions?.criteria?.find(
          (prev: any) => prev?.value === responseData?.criteriaId
        );

        const categoryObj = formOptions?.category?.find(
          (prev: any) => prev?.value === responseData?.categoryId
        );

        // const documentsObj = formOptions?.documents?.find(
        //   (prev: any) => prev?.value === responseData?.documentsId
        // );

        const documentsObj = responseData?.documentId
          ?.split(",")
          .map((val: any) => val.trim())
          .map((val: any) => Number(val));

        form.setFieldsValue({
          financialYear: responseData?.financialYearId, //financialYearObj,
          type: responseData?.typeId, //typeObj,
          regime: regimeObj,
          section: responseData?.sectionId, //sectionObj,
          component: responseData?.componentId, //componentObj,
          criteria: responseData?.criteriaId, //criteriaObj,
          category: responseData?.categoryId, //categoryObj,
          documents: documentsObj,
          maxLimit: responseData?.maxLimit,
          description: responseData?.description,
          isReplicable: responseData?.isReplicable,
        });

        setFormData({
          regime: regimeObj,
          section: responseData?.sectionId,
          component: responseData?.componentId,

          financialYear: responseData?.financialYearId,
          type: responseData?.typeId,
          criteria: responseData?.criteriaId,
          category: responseData?.categoryId,
          documents: documentsObj,
          maxLimit: responseData?.maxLimit,
          description: responseData?.description,
          isReplicable: responseData?.isReplicable,
        });

        if (responseData.additionalFieldList.length > 0) {
          setShowAdditionalField(true);
          const fields: IAdditionalField[] =
            responseData.additionalFieldList.map((item: any) => ({
              id: item.Id,
              fieldName: item.fieldName,
              responseType: item.responseType,
              choices: item.choices,
              minValue: item.minValue,
              maxValue: item.maxValue,
              charLimit: item.charLimit,
              isMandatory: item.isMandatory,
              regex: item.regex,
            }));

          // Set the state with the mapped fields
          setAdditionalFields(fields);

          const additionalFieldsValues = fields.reduce(
            (acc: any, field: any, index: any) => {
              acc[`fieldName${index}`] = field.fieldName;
              acc[`responseType${index}`] = field.responseType;
              acc[`choices${index}`] = field.choices;
              acc[`minValue${index}`] = field.minValue;
              acc[`maxValue${index}`] = field.maxValue;
              acc[`charLimit${index}`] = field.charLimit;
              acc[`isMandatory${index}`] = field.isMandatory;
              acc[`regex${index}`] = field.regex;
              return acc;
            },
            {}
          );

          // Set form values for the additional fields
          form.setFieldsValue(additionalFieldsValues);

          //console.error("additionalFields : ", additionalFields);
        }
      }
    } catch (error) {
      console.error("Error : ", error);
    }
    hideLoader();
  };

  const deleteAdditionalField = async (index: any) => {
    //var result = false;
    //result = window.confirm("Are you sure you want to delete ?");
    //if (result) {

    confirm({
      content: "Are you sure you want to delete ?",
      okText: "Ok",
      cancelText: "Cancel",
      async onOk() {
        if (additionalFields[index]?.id == 0) {
          const updatedFields = additionalFields.filter(
            (item, itemindex) => itemindex !== index
          );
          setAdditionalFields(updatedFields);
        } else {
          handleDeleteAdditionalField("Delete", additionalFields[index]?.id);
          const updatedFields = additionalFields.filter(
            (item, itemindex) => itemindex !== index
          );
          setAdditionalFields(updatedFields);
        }
      },
      onCancel() { },
    });
    //}
  };

  const handleDeleteAdditionalField = async (actionType: string, id: any) => {
    try {
      showLoader();

      let response = await API.post(deletePOIAdditionalField, {
        AdditionalFieldId: id,
      });

      if (response.data) {
        message.success("Deleted successfully.");
      } else {
        message.success("Failed to dlete");
      }
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      message.error(`Failed to perform getDropdowns`);
    } finally {
      hideLoader();
    }
  };

  const actionColumnConfiguration = {
    // element: "action",
    actionButtons: [
      {
        type: "Edit",
        icon: <EditOutlined />,
        onClick: (record: any) => handleEditConfiguration("Edit", record),
      },
      {
        type: "delete",
        icon: <DeleteOutlined />,
        onClick: (record: any) => handleDeleteConfiguration("delete", record),
      },
      // {
      //   type: "View",
      //   label: "View",
      //   icon: <HistoryOutlined />,
      //   onClick: (record: any) => handleActionClick("View", record),
      // },
    ],
  };

  const handleSectionChange = (e: any, option: any) => {
    const selectedCode = option ? option.code : null;
    formOnChange(e, "section");
    setSectionMaxLimit(selectedCode);
  };

  const handleComponentChange = (e: any, option: any) => {
    const selectedCode = option ? option.code : null;
    formOnChange(e, "component");
    //bindMaxLimit(selectedCode, "component");
    setComponentMaxLimit(selectedCode);
  };

  useEffect(() => {
    if (sectionMaxLimit != "") {
      bindMaxLimit(sectionMaxLimit, "section");
    }
  }, [sectionMaxLimit]);

  useEffect(() => {
    if (componentMaxLimit != "") {
      bindMaxLimit(componentMaxLimit, "component");
    }
  }, [componentMaxLimit]);

  return (
    <>
      {
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 ">
              {/* <div className="form-container m-0 mt-3"> */}
              <>
                {/* <Collapse
                      className="Collapse-container my-3 mx-0"
                      key={"newform"}
                      defaultActiveKey={[1]} > */}

                <Form form={form} layout="vertical" validateTrigger="onChange">
                  {showForm && (
                    <Row gutter={[8, 8]} key={"newform"}>
                      <Col xs={24} sm={6} md={6}>
                        <FormSelect
                          name={"financialYear"}
                          label={"Financial Year"}
                          rules={[
                            {
                              required: "true",
                              message: `Financial Year is required`,
                            },
                          ]}
                          placeholder={"Select Financial Year"}
                          widthSize={undefined}
                          options={formOptions?.financialYear}
                          mode={undefined}
                          value={formData?.financialYear}
                          onChange={(e: any) =>
                            formOnChange(e, "financialYear")
                          }
                        />
                        {formErrors["financialYear"] && (
                          <p style={{ color: "red",marginTop:-10 }}>
                            {formErrors["financialYear"]}
                          </p>
                        )}
                      </Col>

                      <Col xs={24} sm={6} md={6}>
                        <FormSelect
                          name={"type"}
                          label={"Type"}
                          rules={[
                             { required: true, message: `Type is required` },
                          ]}
                          placeholder={"Select Type"}
                          widthSize={undefined}
                          options={formOptions?.type}
                          mode={undefined}
                          value={formData?.type}
                          onChange={(value: any) => formOnChange(value, "type")}
                        />
                        {formErrors["type"] && (
                          <p style={{ color: "red",marginTop:-10 }}>{formErrors["type"]}</p>
                        )}
                      </Col>

                      <Col xs={24} sm={6} md={6}>
                        <FormSelect
                          name={"regime"}
                          label={"Regime"}
                          rules={[
                            {
                              required: "true",
                              message: `Regime is required`,
                            },
                          ]}
                          placeholder={"Select Regime"}
                          widthSize={undefined}
                          options={formOptions?.regime}
                          mode={"multiple"}
                          value={formData?.regime}
                          onChange={(e: any) => formOnChange(e, "regime")}
                        />
                        {formErrors["regime"] && (
                          <p style={{ color: "red",marginTop:-10  }}>{formErrors["regime"]}</p>
                        )}
                      </Col>

                      <Col xs={24} sm={6} md={6}>
                        <FormSelect
                          name={"section"}
                          label={"Section"}
                          rules={[
                            {
                              required: true,
                              message: `Section is required`,
                            },
                          ]}
                          placeholder={"Select Section"}
                          widthSize={undefined}
                          options={formOptions?.section}
                          mode={undefined}
                          value={formData?.section}
                          onChange={(e: any, option: any) =>
                            handleSectionChange(e, option)
                          }
                        />
                        {formErrors["section"] && (
                          <p style={{ color: "red",marginTop:-10  }}>
                            {formErrors["section"]}
                          </p>
                        )}
                      </Col>

                      <Col xs={24} sm={6} md={6}>
                        <FormSelect
                          name={"component"}
                          label={"Component"}
                          rules={undefined}
                          placeholder={"Select Component"}
                          widthSize={undefined}
                          options={formOptions?.component}
                          mode={undefined}
                          value={formData?.component}
                          onChange={(e: any, option: any) =>
                            handleComponentChange(e, option)
                          }
                        />
                      </Col>

                      {/* <Col xs={24} sm={6} md={6}>
                        <FormSelect
                          name={"criteria"}
                          label={"Criteria"}
                          rules={undefined}
                          placeholder={"Select Criteria"}
                          widthSize={undefined}
                          options={formOptions?.criteria}
                          mode={undefined}
                          value={formData?.criteria}
                          onChange={(e: any) => formOnChange(e, "criteria")}
                        />
                      </Col> */}

                      <Col xs={24} sm={6} md={6}>
                        <FormSelect
                          name={"category"}
                          label={"Category"}
                          rules={[
                            {
                              required: true,
                              message: `Category is required`,
                            },
                          ]}
                          placeholder={"Select Category"}
                          widthSize={undefined}
                          options={formOptions?.category}
                          mode={undefined}
                          value={formData?.category}
                          onChange={(e: any) => formOnChange(e, "category")}
                        />
                        {formErrors["category"] && (
                          <p style={{ color: "red",marginTop:-10  }}>
                            {formErrors["category"]}
                          </p>
                        )}
                      </Col>

                      <Col xs={24} sm={6} md={6}>
                        <FormInput
                          name={"maxLimit"}
                          label={"Max Limit"}
                          rules={undefined}
                          placeholder={"Enter MaxLimit"}
                          widthSize={"100%"}
                          textArea={false}
                          inputType={"text"}
                          disabled={true}
                          onChange={(e: any) => formOnChange(e, "maxLimit")}
                          onKeyPress={(e) => {
                            const charCode = e.which ? e.which : e.keyCode;
                            const char = String.fromCharCode(charCode);

                            // Allow digits
                            if (/^\d$/.test(char)) {
                              return;
                            }
                            // // Allow only one dot
                            // if (char === "." && !e.currentTarget.value.includes(".")) {
                            //   return;
                            // }
                            // Block anything else (letters, symbols, negative sign)
                            e.preventDefault();
                          }}
                          value={formData?.maxLimit}
                        />
                      </Col>

                      <Col xs={24} sm={6} md={6}>
                        <FormInput
                          name={"description"}
                          label={"Description"}
                          rules={undefined}
                          placeholder={"Enter Description"}
                          widthSize={undefined}
                          textArea={true}
                          inputType={"text"}
                          onChange={(e: any) => formOnChange(e, "description")}
                          value={formData?.description}                          
                        />
                      </Col>

                      <Col xs={24} sm={6} md={6}>
                        <FormSelect
                          name={"documents"}
                          label={"Documents"}
                          rules={[
                            {
                              required: true,
                              message: `Documents is required`,
                            },
                          ]}
                          placeholder={"Select Documents"}
                          widthSize={undefined}
                          options={formOptions?.documents}
                          mode={"multiple"}
                          value={formData?.documents}
                          onChange={(e: any) => formOnChange(e, "documents")}
                        />
                        {formErrors["documents"] && (
                          <p style={{ color: "red",marginTop:-10  }}>
                            {formErrors["documents"]}
                          </p>
                        )}
                      </Col>

                      <Col xs={24} sm={6} md={6}>
                        <FormCheckbox
                          name={"isReplicable"}
                          label={"IsReplicable"}
                          required={false}
                          checked={formData?.isReplicable || false}
                          onChange={(e: any) => {
                            formOnChange(e.target.checked, "isReplicable");
                          }}
                        />
                      </Col>

                      {/* <Col xs={24} sm={6} md={6}></Col> */}
                      <Col xs={24} sm={6} md={6}></Col>
                      <Col lg={24}>
                        <div className="mt-2">
                          <p className="m-0">
                            (Alternative documents should be mentioned together
                            as a single entry, e.g. Payment receipt or Passbook
                            copy)
                          </p>
                        </div>
                      </Col>
                      <Col xs={24} sm={6} md={6}></Col>

                      <Col lg={24}>
                        <a
                          href="javascript:void(0)"
                          onClick={() => toggleAdditionalField()}
                        >
                          Additional Fields
                        </a>
                      </Col>
                    </Row>
                  )}

                  {showAdditionalField &&
                    additionalFields.map((item: any, index: any) => (
                      <div className="master_grid mt-4">
                        <h2>{"Field " + (index + 1)}</h2>
                        <div className={"master_inner"}>
                          <Row gutter={[16, 8]} key={index}>
                            <Col xs={24} sm={6} md={6} lg={5}>
                              <FormSelect
                                name={"type"}
                                label={"Type"}
                                rules={[
                                  {
                                    required: true,
                                    message: `Type is required`,
                                  },
                                ]}
                                placeholder={"Select Type"}
                                widthSize={undefined}
                                options={formOptions?.type}
                                mode={undefined}
                                onChange={(e: any) => formOnChange(e, "type")}
                                value={formData?.type}
                                disabled={true}
                              />
                            </Col>
                            <Col xs={24} sm={6} md={6}>
                              <FormInput
                                name={"fieldName" + index}
                                label={"Field Name"}
                                rules={[
                                  {
                                    required: true,
                                    message: `Field Name is required`,
                                  },
                                ]}
                                placeholder={"Enter Field Name"}
                                widthSize={undefined}
                                textArea={false}
                                inputType={"text"}
                                onChange={(e: any) =>
                                  additionalFormOnChange(
                                    e,
                                    "fieldName" + index,
                                    index
                                  )
                                }
                                value={item.fieldName || ""}
                              />
                              {additionalFormErrors[index]?.["fieldName"] && (
                                <p style={{ color: "red",marginTop:-10, marginLeft:8  }}>
                                  {additionalFormErrors[index]?.["fieldName"]}
                                </p>
                              )}
                            </Col>

                            <Col xs={24} sm={6} md={6} lg={5}>
                              <FormSelect
                                name={"responseType" + index}
                                label={"Response Type"}
                                rules={[
                                  {
                                    required: true,
                                    message: `Response Type is required`,
                                  },
                                ]}
                                placeholder={"Select Response Type"}
                                widthSize={undefined}
                                options={formOptions?.responseType}
                                mode={undefined}
                                onChange={(e: any, option: any) => {
                                  const selectedLabel = option
                                    ? option.label
                                    : null;
                                  additionalFormOnChange(
                                    selectedLabel,
                                    "responseType" + index,
                                    index
                                  );
                                }}
                                value={item.responseType || ""}
                              />
                              {additionalFormErrors[index]?.[
                                "responseType"
                              ] && (
                                <p style={{ color: "red",marginTop:-10 ,marginLeft:8  }}>
                                  {
                                    additionalFormErrors[index]?.[
                                      "responseType"
                                    ]
                                  }
                                </p>
                              )}
                            </Col>

                            {additionalFields[
                              index
                            ].responseType.toLocaleLowerCase() == "numeric" && (
                              <>
                                <Col xs={24} sm={6} md={6} lg={5}>
                                  <FormInput
                                    name={"minValue" + index}
                                    label={"Min Value"}
                                    rules={[
                                      {
                                        required: true,
                                        message: `Min Value is required`,
                                      },
                                    ]}
                                    placeholder={"Enter Min Value"}
                                    widthSize={undefined}
                                    textArea={false}
                                    inputType={"text"}
                                    onChange={(e: any) =>
                                      additionalFormOnChange(
                                        e,
                                        "minValue" + index,
                                        index
                                      )
                                    }
                                    onKeyPress={(e) => {
                                      const charCode = e.which
                                        ? e.which
                                        : e.keyCode;
                                      const char =
                                        String.fromCharCode(charCode);
                                      const value = e.currentTarget.value;

                                      // Allow digits
                                      if (/^\d$/.test(char)) {
                                        return;
                                      }
                                      // Allow minus sign only at the start and only once
                                      if (char === "-" && value.length === 0) {
                                        return;
                                      }
                                      // // Allow only one dot
                                      // if (char === "." && !e.currentTarget.value.includes(".")) {
                                      //   return;
                                      // }
                                      // Block anything else (letters, symbols, negative sign)
                                      e.preventDefault();
                                    }}
                                    value={item.minValue || ""}
                                  />
                                  {additionalFormErrors[index]?.[
                                    "minValue"
                                  ] && (
                                    <p style={{ color: "red",marginTop:-10,marginLeft:8   }}>
                                      {
                                        additionalFormErrors[index]?.[
                                          "minValue"
                                        ]
                                      }
                                    </p>
                                  )}
                                </Col>

                                <Col xs={24} sm={6} md={6} lg={5}>
                                  <FormInput
                                    name={"maxValue" + index}
                                    label={"Max Value"}
                                    rules={[
                                      {
                                        required: true,
                                        message: `Max Value is required`,
                                      },
                                    ]}
                                    placeholder={"Enter Max Value"}
                                    widthSize={undefined}
                                    textArea={false}
                                    inputType={"text"}
                                    onChange={(e: any) =>
                                      additionalFormOnChange(
                                        e,
                                        "maxValue" + index,
                                        index
                                      )
                                    }
                                    onKeyPress={(e) => {
                                      const charCode = e.which
                                        ? e.which
                                        : e.keyCode;
                                      const char =
                                        String.fromCharCode(charCode);
                                      const value = e.currentTarget.value;

                                      // Allow digits
                                      if (/^\d$/.test(char)) {
                                        return;
                                      }
                                      // Allow minus sign only at the start and only once
                                      if (char === "-" && value.length === 0) {
                                        return;
                                      }
                                      // // Allow only one dot
                                      // if (char === "." && !e.currentTarget.value.includes(".")) {
                                      //   return;
                                      // }
                                      // Block anything else (letters, symbols, negative sign)
                                      e.preventDefault();
                                    }}
                                    value={item.maxValue || ""}
                                  />
                                  {additionalFormErrors[index]?.[
                                    "maxValue"
                                  ] && (
                                    <p style={{ color: "red",marginTop:-10,marginLeft:8   }}>
                                      {
                                        additionalFormErrors[index]?.[
                                          "maxValue"
                                        ]
                                      }
                                    </p>
                                  )}
                                </Col>
                              </>
                            )}
                            {additionalFields[
                              index
                            ].responseType.toLocaleLowerCase() ==
                              "text input" && (
                              <>
                                <Col xs={24} sm={6} md={6} lg={5}>
                                  <FormInput
                                    name={"charLimit" + index}
                                    label={"Char Limit"}
                                    rules={[
                                      {
                                        required: true,
                                        message: `Char Limit is required`,
                                      },
                                    ]}
                                    placeholder={"Enter Char Limit"}
                                    widthSize={undefined}
                                    textArea={false}
                                    inputType={"text"}
                                    onChange={(e: any) =>
                                      additionalFormOnChange(
                                        e,
                                        "charLimit" + index,
                                        index
                                      )
                                    }
                                    value={item.charLimit || ""}
                                  />
                                  {additionalFormErrors[index]?.[
                                    "charLimit"
                                  ] && (
                                    <p style={{ color: "red",marginTop:-10,marginLeft:8   }}>
                                      {
                                        additionalFormErrors[index]?.[
                                          "charLimit"
                                        ]
                                      }
                                    </p>
                                  )}
                                </Col>
                              </>
                            )}
                            {(additionalFields[
                              index
                            ].responseType.toLocaleLowerCase() == "choices" ||
                              additionalFields[
                                index
                              ].responseType.toLocaleLowerCase() ==
                                "radio button" ||
                              additionalFields[
                                index
                              ].responseType.toLocaleLowerCase() ==
                                "dropdown") && (
                              <>
                                <Col xs={24} sm={6} md={6} lg={5}>
                                  <FormInput
                                    name={"choices" + index}
                                    label={"Choices (comma separated)"}
                                    rules={[
                                      {
                                        required: "true",
                                        message: `Choices is required`,
                                      },
                                    ]}
                                    placeholder={"Enter Choices"}
                                    // widthSize={undefined}
                                    textArea={true}
                                    // inputType={"text"}
                                    onChange={(e: any) =>
                                      additionalFormOnChange(
                                        e,
                                        "choices" + index,
                                        index
                                      )
                                    }
                                    value={
                                      additionalFields[index].choices || ""
                                    }
                                  />
                                  {additionalFormErrors[index]?.["choices"] && (
                                    <p style={{ color: "red",marginTop:-10,marginLeft:8   }}>
                                      {additionalFormErrors[index]?.["choices"]}
                                    </p>
                                  )}
                                </Col>
                              </>
                            )}

                            {additionalFields[
                              index
                            ].responseType.toLocaleLowerCase() ==
                              "text input" && (
                              <Col xs={24} sm={6} md={6} lg={5}>
                                <FormSelect
                                  name={"regex" + index}
                                  label={"Regex"}
                                  rules={undefined}
                                  placeholder={"Enter Regex"}
                                  widthSize={undefined}
                                  options={formOptions?.regex}
                                  mode={undefined}
                                  onChange={(e: any, option: any) => {
                                    const selectedLabel = option
                                      ? option.label
                                      : null;
                                    additionalFormOnChange(
                                      selectedLabel,
                                      "regex" + index,
                                      index
                                    );
                                  }}
                                  value={item.regex || ""}
                                />
                                {additionalFormErrors[index]?.["regex"] && (
                                  <p style={{ color: "red" ,marginTop:-10 ,marginLeft:8 }}>
                                    {additionalFormErrors[index]?.["regex"]}
                                  </p>
                                )}
                              </Col>
                            )}

                            {/* <Col xs={24} sm={6} md={6}>
                            <FormCheckbox
                              name={"isDependent" + index}
                              label={"IsDependent"}
                              required={false}
                              checked={item?.isDependent || false}
                              onChange={(e: any) =>
                                additionalFormOnChange(
                                  e,
                                  "isDependent" + index,
                                  index
                                )
                              }
                              //value={additionalFields[index].isMandatory}
                            />
                          </Col> */}

                            {/* {additionalFields[index].isDependent && (
                            <>
                              <Col xs={24} sm={6} md={6}>
                                <FormSelect
                                  name={"dependentFieldDropdown" + index}
                                  label={"Dependent Field Dropdown"}
                                  rules={[{ required: "true" }]}
                                  placeholder={"Dependent Field Dropdown"}
                                  widthSize={undefined}
                                  options={formOptions?.dependentFieldDropdown}
                                  mode={undefined}
                                  onChange={(e: any, option: any) => {
                                    debugger;
                                    const selectedLabel = option
                                      ? option.label
                                      : null;
                                    additionalFormOnChange(
                                      selectedLabel,
                                      "dependentFieldDropdown" + index,
                                      index
                                    );
                                  }}
                                  value={item.dependentFieldDropdown || ""}
                                />
                                {additionalFormErrors[index]?.[
                                  "dependentFieldDropdown"
                                ] && (
                                  <p style={{ color: "red" }}>
                                    {
                                      additionalFormErrors[index]?.[
                                        "dependentFieldDropdown"
                                      ]
                                    }
                                  </p>
                                )}
                              </Col>

                              <Col xs={24} sm={6} md={6}>
                                <FormSelect
                                  name={
                                    "dependentFieldResponseDropdown" + index
                                  }
                                  label={"Dependent Field Response Dropdown"}
                                  rules={[{ required: "true" }]}
                                  placeholder={
                                    "Dependent Field Response Dropdown"
                                  }
                                  widthSize={undefined}
                                  options={
                                    formOptions?.dependentFieldResponseDropdown
                                  }
                                  mode={undefined}
                                  onChange={(e: any, option: any) => {
                                    debugger;
                                    const selectedLabel = option
                                      ? option.label
                                      : null;
                                    additionalFormOnChange(
                                      selectedLabel,
                                      "dependentFieldResponseDropdown" + index,
                                      index
                                    );
                                  }}
                                  value={
                                    item.dependentFieldResponseDropdown || ""
                                  }
                                />
                                {additionalFormErrors[index]?.[
                                  "dependentFieldResponseDropdown"
                                ] && (
                                  <p style={{ color: "red" }}>
                                    {
                                      additionalFormErrors[index]?.[
                                        "dependentFieldResponseDropdown"
                                      ]
                                    }
                                  </p>
                                )}
                              </Col>

                              <Col xs={24} sm={6} md={6}>
                                <FormCheckbox
                                  name={"isHidden" + index}
                                  label={"IsHidden"}
                                  required={false}
                                  checked={item?.isHidden || false}
                                  onChange={(e: any) =>
                                    additionalFormOnChange(
                                      e,
                                      "isHidden" + index,
                                      index
                                    )
                                  }
                                />
                              </Col>
                            </>
                          )} */}

                            <Col xs={24} sm={6} md={6} lg={2}>
                              <FormCheckbox
                                name={"isMandatory" + index}
                                label={"IsMandatory"}
                                required={false}
                                checked={item?.isMandatory || false}
                                onChange={(e: any) =>
                                  additionalFormOnChange(
                                    e,
                                    "isMandatory" + index,
                                    index
                                  )
                                }
                                //value={additionalFields[index].isMandatory}
                              />
                            </Col>
                            <Col
                              xs={24}
                              sm={6}
                              md={6}
                              style={{ paddingTop: "32px" }}
                            >
                              <a
                                href="javascript:void(0)"
                                onClick={(value: any) =>
                                  deleteAdditionalField(index)
                                }
                              >
                                <DeleteOutlined />
                              </a>
                            </Col>

                            {/* <Divider
                                style={{
                                  height: "1px",
                                  border: "none",
                                  margin: "32px 0",
                                  background:
                                    "linear-gradient(to right, rgba(61, 38, 121, 0) 0%, rgba(94, 41, 228, 0.4) 25%, rgba(99, 48, 230, 0.4) 75%, rgba(61, 38, 121, 0) 100%)",
                                }}
                              /> */}
                          </Row>
                        </div>
                      </div>
                    ))}

                  {showAdditionalField && (
                    <div className="button-area mt-2">
                      <div className="button-section">
                        {
                          <>
                            <button
                              className="btn-viewsub"
                              type="button"
                              // onClick={() =>
                              //   handleButtonClick(form, field.actionKey.toLowerCase())
                              // }
                              onClick={(value: any) => addAdditionalField()}
                            >
                              {"Add"}
                            </button>
                          </>
                        }
                      </div>
                    </div>
                  )}

                  {showForm && (
                    <div className="button-area mt-2 mb-2">
                      <div className="button-section">
                        {
                          <>
                            <button
                              type="button"
                              className="btn-reset"
                              onClick={() => {
                                resetFunction();
                              }}
                              //onClick={resetFunction}
                              // onClick={() => handleButtonClick(form, "cancel")}
                            >
                              Reset
                            </button>
                            <button
                              className="btn-submit"
                              type="button"
                              onClick={() => {
                                handleSaveFunction();
                              }}
                              // onClick={() =>
                              //   handleButtonClick(form, field.actionKey.toLowerCase())
                              // }
                            >
                              {RequestId === 0 ? 'Save' : 'Update' }
                            </button>
                          </>
                        }
                      </div>
                    </div>
                  )}
                </Form>
              </>
            </div>
          </div>
        </div>
      }

      {refreshTable && (
        <ActionHandlerProvider
          rowActionHandler={childRowHandlers}
          reportActionHandler={childReportHandlers}
        >
          <DynamicReport
            handleCreate={handleCreateConfiguration}
            actionColumn={actionColumnConfiguration}
            id={0}
            dashboardId={4}
          />
        </ActionHandlerProvider>
      )}
    </>
  );
}
